<template>
    <b-modal id="bv-modal-ticket" size="xl" :title="'Ticket #' + ticketInfo.protocol" scrollable centered no-stackin>
        <b-container fluid>
            <div class="ticket-details">
                <div>
                    <div class="ticket-info">
                        <div class="info-grid">
                            <div class="info-item">
                                <div class="info-label">Protocolo:</div>
                                <div class="info-value" id="ticketId">{{ ticketInfo.protocol }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Chamado:</div>
                                <input type="text" v-if="editMode" class="input-edit-mode" id="chamado"
                                    v-model="ticketInfo.chamado">
                                <div class="info-value" v-else id="chamado">{{ ticketInfo.chamado }}</div>
                            </div>

                            <div class="info-item" v-if="ticketInfo?.ref_protocol">
                                <div class="info-label">Ref. Protocolo:</div>
                                <div class="info-value" id="ref_protocol">{{ ticketInfo.ref_protocol }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Cliente:</div>
                                <input type="text" v-if="editMode" class="input-edit-mode" id="clientName"
                                    v-model="ticketInfo.client">
                                <div class="info-value" v-else id="clientName">{{ ticketInfo.client }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Entrada:</div>
                                <div class="info-value" id="clientEmail">{{ ticketInfo.email_config }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">E-mail:</div>
                                <div class="info-value" id="clientEmail">{{ ticketInfo.email[0] }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Atendente:</div>
                                <select id="owners" v-model="selectedFields.user" class="input-edit-mode"
                                    v-if="editMode">
                                    <option value="">Selecione um atendente</option>
                                    <option v-for="user in filteredUsers" :key="user.id" :value="user.id">
                                        {{ user.name }}
                                    </option>
                                </select>

                                <div v-else class="info-value" id="assignedAgent">{{ ticketInfo.owner_user?.name ?? ""
                                }}
                                </div>
                            </div>

                            <div class="info-item" v-if="ticketInfo?.keyword">
                                <div class="info-label">{{ handleKeyWordText(ticketInfo.keyword) }}:</div>
                                <div class="info-value" id="clientEmail">{{ ticketInfo.keyword?.keyword ??
                                    ticketInfo.keyword?.name }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Grupo:</div>
                                <select id="groups" v-model="selectedFields.group" class="input-edit-mode"
                                    v-if="editMode">
                                    <option value="">Selecione um grupo</option>
                                    <option v-for="group in allGroups" :key="group.id" :value="group.id">
                                        {{ group.name }}
                                    </option>
                                </select>

                                <div v-else class="info-value" id="assignedAgent">{{ ticketInfo.owner_group?.name ?? ""
                                }}
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Status:</div>
                                <div class="info-value">
                                    <select name="status" id="status" v-if="editMode" class="input-edit-mode"
                                        v-model="selectedStatus">
                                        <option v-for="status in statuses" :key="status.id" :value="status.id">
                                            {{ camelCaseString(status.name) }}
                                        </option>
                                    </select>

                                    <span v-else class="highlight-badge" :style="dinamicStyle(ticketInfo.status.color)">
                                        {{ camelCaseString(ticketInfo.status.name) }}
                                    </span>
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Prioridade:</div>
                                <div class="info-value">
                                    <select name="priority" v-if="editMode" id="priority" class="input-edit-mode"
                                        v-model="selectedFields.priority">
                                        <option v-for="priority in prioritiesList" :key="priority.id"
                                            :value="priority.id">
                                            {{ camelCaseString(priority.name) }} ({{ convertSecondsToTime(priority.time)
                                            }})
                                        </option>
                                    </select>

                                    <span v-else class="highlight-badge"
                                        :style="dinamicStyle(ticketInfo.priority.color)">
                                        {{ camelCaseString(ticketInfo.priority.name) }}
                                    </span>
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">SLA:</div>
                                <div class="info-value">
                                    <div class="sla-indicator">
                                        <span v-html="handleTicketSLA(ticketInfo, slaTick)"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Criado em:</div>
                                <div class="info-value">{{ formatDate(ticketInfo.created_at) }}</div>
                            </div>

                            <div class="info-item">
                                <div class="info-label">Atualizado em:</div>
                                <div class="info-value">{{ formatDate(ticketInfo.updatedAt) }}</div>
                            </div>

                            <div class="info-item" v-if="ticketInfo?.received_at">
                                <div class="info-label">Recebido em:</div>
                                <div class="info-value">{{ formatDate(ticketInfo.received_at) }}</div>
                            </div>

                            <div class="info-item" v-if="ticketInfo?.closed_at">
                                <div class="info-label">Concluído em:</div>
                                <div class="info-value">{{ formatDate(ticketInfo.closed_at) }}</div>
                            </div>

                            <div class="info-item" v-if="ticketInfo?.closed_by">
                                <div class="info-label">Concluído por:</div>
                                <div class="info-value">{{ ticketInfo.closed_by }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="comment-form" style="margin-bottom: 10px;" v-if="editMode && closingComment.visible">
                        <textarea class="comment-input" name="closing-comment"
                            placeholder="Adicione um comentário para finalização do ticket"
                            v-model="closingComment.text"></textarea>
                    </div>

                    <div class="btns-edit">
                        <button class="btn btn-task-shortcut" @click="openNewTask"><i class="fas fa-plus"></i> Nova
                            Tarefa</button>

                        <div>
                            <button class="btn btn-secondary" v-show="!editMode" @click="editMode = true"><i
                                    class="fas fa-edit"></i> Editar</button>

                            <button class="btn btn-primary" v-show="editMode" @click="updateTicket()"><i
                                    class="far fa-save"></i> Salvar</button>

                            <button class="btn btn-danger" v-show="editMode" @click="cancelEdit()"><i
                                    class="far fa-times-circle"></i> Cancelar</button>
                        </div>
                    </div>

                    <div class="email-content-area">
                        <h4>
                            <i class="fas fa-envelope"></i> Conteúdo dos e-mails
                            <span class="badge badge-danger">{{ allEmails ? allEmails?.length : 0 }}</span>
                        </h4>

                        <div class="accordion" id="emailsAccordion">
                            <div class="card email-card-accordion" v-for="(email, index) in allEmails" :key="email.id">
                                <div class="card-header" :id="'heading' + index">
                                    <h2 class="mb-0">
                                        <button
                                            class="btn btn-outline-dark collapsed w-100 text-left d-flex justify-content-between align-items-center"
                                            type="button" data-toggle="collapse" :data-target="'#collapse' + index"
                                            :aria-expanded="false" :aria-controls="'collapse' + index">
                                            <div>
                                                <strong>
                                                    {{ ticketInfo.email_id == email.id ? `⭐ ${email.subject}` :
                                                    email.subject }}
                                                </strong>
                                                <small class="text-muted ml-2">{{ emailSubTitle(email) }}</small>
                                            </div>
                                            <i class="fas fa-chevron-down"></i>
                                        </button>
                                    </h2>
                                </div>

                                <div :id="'collapse' + index" class="collapse" :aria-labelledby="'heading' + index">
                                    <div class="card-body">
                                        <div class="email-content-header">
                                            <h5>{{ email.subject }}</h5>
                                            <p>
                                                <strong> {{ email.is_received ? "Recebido" : "Enviado" }} em: </strong>
                                                {{ formatDate(email.created_at) }}
                                            </p>
                                            <p><strong>De: </strong>{{ handleEmailsArray(email.from_email) }}</p>
                                            <p><strong>Para: </strong>{{ handleEmailsArray(email.to_email) }}</p>
                                            <p v-if="email.copy_email?.length">
                                                <strong>Cópia: </strong>{{ handleEmailsArray(email.copy_email) }}
                                            </p>
                                        </div>

                                        <div class="email-content-body">
                                            <div style="overflow-x: auto; max-width: 985px;" v-html="email.body"></div>

                                            <div class="composer-attachments"
                                                v-if="email.attachments && email.attachments?.length > 0">
                                                <h5>Anexos:</h5>
                                                <ul>
                                                    <li v-for="(attachment, attachIndex) in email.attachments"
                                                        :key="attachIndex">
                                                        <span>
                                                            <i :class="getFileIcon(attachment.filename)"></i>
                                                            <span>{{ textSizeLimit(attachment.filename, 22) }}</span>
                                                            <small class="attachment-size">({{
                                                                formatFileSize(attachment.size) }})</small>
                                                        </span>
                                                        <button
                                                            @click="downloadAttachment(email.id, attachment.filename)"
                                                            class="download-attachment-btn" title="Download anexo">
                                                            <i class="fas fa-download"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div style="display: flex; gap: 8px;">
                                            <button class="btn btn-warning" @click="openEmailEditor(email)">
                                                <i class="fas fa-reply"></i> Responder E-mail
                                            </button>
                                            <button class="btn btn-success" @click="openEmailEditor(email, true)">
                                                <i class="fas fa-share"></i> Encaminhar E-mail
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <EmailEditor :visible="showEmailEditor" @close="showEmailEditor = false"
                            :responseData="replyEmail" @emailSent="eventEmailSent">
                        </EmailEditor>
                    </div>

                    <div class="comment-section">
                        <div class="timeline">
                            <div class="timeline-header">
                                <h4>
                                    <i class="fas fa-comments"></i> Comentários <span class="badge badge-danger">{{
                                        ticketInfo?.comments ? ticketInfo.comments?.length : 0 }}</span>
                                </h4>
                                <button class="btn btn-primary" @click="showComments = !showComments">
                                    <span v-show="!showComments"><i class="fas fa-eye"></i> Exibir</span>
                                    <span v-show="showComments"><i class="fas fa-eye-slash"></i> Ocultar</span>
                                </button>
                            </div>

                            <div class="timeline-item" v-if="ticketInfo.comments && showComments"
                                v-for="comment in ticketInfo.comments" :key="comment.id">
                                <div class="timeline-icon">{{ comment.id % 2 == 1 ? "💬" : "🗨️" }}</div>
                                <div class="timeline-content">
                                    <div class="timeline-title">{{ comment?.created_by?.name ?? "" }}</div>
                                    <div class="timeline-time">{{ formatDate(comment.created_at) }}</div>
                                    <div class="timeline-description">{{ comment.text }}</div>
                                </div>
                            </div>

                            <div :class="[showComments ? 'writter-comment-area' : '']">
                                <h5><i class="fas fa-pen-nib"></i> Escrever um novo comentário:</h5>
                                <div class="comment-form">
                                    <textarea class="comment-input"
                                        placeholder="Adicione um comentário interno (não será enviado ao cliente)..."
                                        v-model="newComment"></textarea>

                                    <div class="comment-actions">
                                        <button class="btn btn-primary" @click="saveComment()"><i
                                                class="fas fa-save"></i> Adicionar Comentário</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="timeline">
                    <div class="timeline-header">
                        <h4>
                            <i class="far fa-clock"></i> Linha do Tempo <span class="badge badge-danger">{{
                                ticketInfo?.timeline ? ticketInfo.timeline?.length : 0 }}</span>
                        </h4>
                        <button class="btn btn-primary" @click="showTimeline = !showTimeline">
                            <span v-show="!showTimeline"><i class="fas fa-eye"></i> Exibir</span>
                            <span v-show="showTimeline"><i class="fas fa-eye-slash"></i> Ocultar</span>
                        </button>
                    </div>

                    <div class="timeline-item" v-if="ticketInfo.timeline && showTimeline"
                        v-for="event in ticketInfo.timeline" :key="event.id">
                        <div class="timeline-icon">{{ selectTimelineIcon(event.event) }}</div>
                        <div class="timeline-content">
                            <div class="timeline-title">{{ event.event }}</div>
                            <div class="timeline-time">{{ formatDate(event.created_at) }}</div>
                            <div class="timeline-description">{{ event.detail }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </b-container>

        <TaskFormModal ref="taskFormModal" modal-id="task-form-modal-ticket-details"
            :priorities-list="taskPrioritiesList" :statuses-list="taskStatusesList" :groups-list="taskGroupsList"
            :users-list="taskUsersList" :reasons-list="taskReasonsList" @task-created="newTimelineTask" />

        <template #modal-footer>
            <div class="w-100 d-flex justify-content-between">
                <button v-if="!loadDownload" class="btn btn-success" @click="downloadEmails()">
                    <i class="fas fa-download"></i> Baixar E-mails
                </button>

                <button v-else class="btn btn-success" disabled>
                    <i class="fas fa-spinner fa-pulse"></i> Baixando E-mails
                </button>

                <TicketPDF :ticket="ticketInfo" :emails="allEmails"></TicketPDF>
            </div>
        </template>
    </b-modal>
</template>

<script>
import EmailEditor from '../../emails/EmailEditor.vue';
import CustomPriorityInput from '../CustomPriorityInput.vue';
import TicketPDF from './TicketPDF.vue';
import TaskFormModal from '../../tasks/TaskFormModal.vue';
import { taskManagerAxios } from '../../tasks/connections/taskApiConnection';
import {
    convertSecondsToTime,
    dinamicStyle,
    handleTicketSLA,
    formatDate,
    isTimeWithinPercentage,
    getFileIcon,
    formatFileSize,
    textSizeLimit,
    camelCaseString,
    selectTimelineIcon
} from '../../../helpers/utils';

export default {
    name: "TicketDetailsModal",
    components: {
        EmailEditor,
        CustomPriorityInput,
        TicketPDF,
        TaskFormModal,
    },
    props: {
        groupsList: {
            type: Array,
            default: () => []
        },
        prioritiesList: {
            type: Array,
            default: () => []
        },
        usersList: {
            type: Array,
            default: () => []
        },
        slaTick: {
            type: Number,
            default: 0
        },
    },
    data: () => ({
        showEmailEditor: false,
        showComments: false,
        showTimeline: false,
        editMode: false,
        loadDownload: false,
        closingComment: {
            visible: false,
            text: ''
        },
        selectedStatus: null,
        selectedFields: {
            user: null,
            group: null,
            priority: null,
            status: null,
        },
        originalTicketData: {
            client: "",
        },
        statuses: [],
        newComment: null,
        allGroups: [],
        allUsers: [],
        allEmails: [],
        replyEmail: null,
        taskPrioritiesList: [],
        taskStatusesList: [],
        taskGroupsList: [],
        taskUsersList: [],
        taskReasonsList: [],
        taskMetaLoaded: false,
        ticketInfo: {
            id: null,
            protocol: "",
            chamado: "",
            client: "",
            ref_protocol: "",
            email: "",
            open: "",
            owner_user: null,
            owner_group: null,
            priority: "",
            sla: "",
            status: "",
            subject: "",
            email_id: null,
            emails: [],
            body_email: null,
            from_email: null,
            to_email: null,
            subject_email: null,
            comments: [],
            timeline: [],
            work_schedule: null,
            created_at: "",
            closed_by: null,
            received_at: null,
            updatedAt: "",
            closed_at: null,
        },
    }),
    created() {
        this.getStatuses();
        this.getGroups();
        this.getUsers();
    },
    watch: {
        selectedStatus(value) {
            try {
                const foundStatus = this.statuses.find(item => item.id == value);
                if (foundStatus && (foundStatus?.name == "concluído" || foundStatus?.is_finisher)) {
                    this.closingComment.visible = true;
                } else {
                    this.closingComment.visible = false;
                }
            } catch (error) {
                console.error(error)
            }
        }
    },
    computed: {
        filteredUsers() {
            const seenIds = new Set();
            const result = [];
            const addUser = (id) => {
                if (id && !seenIds.has(id)) {
                    const u = this.allUsers.find(u => u.id === id);
                    if (u) { result.push(u); seenIds.add(id); }
                }
            };

            const selectedGroup = this.allGroups.find(g => g.id === this.selectedFields.group);
            const memberIds = selectedGroup ? new Set(selectedGroup.members.map(m => m.id)) : new Set();
            const assignedUserId = this.ticketInfo.owner_user?.id ?? null;
            addUser(assignedUserId);
            this.allUsers.forEach(u => { if (memberIds.has(u.id)) addUser(u.id); });
            return result;
        },
    },
    methods: {
        convertSecondsToTime,
        dinamicStyle,
        handleTicketSLA,
        formatDate,
        isTimeWithinPercentage,
        getFileIcon,
        formatFileSize,
        textSizeLimit,
        camelCaseString,
        selectTimelineIcon,
        openEmailEditor(email, isForward = false) {
            if (!email?.ticket_id && this.ticketInfo?.id) {
                email.ticket_id = this.ticketInfo.id;
            }

            if (isForward) {
                this.replyEmail = {
                    id: email.id,
                    in_reply_to: null,
                    protocol: this.ticketInfo.protocol,
                    subject_email: email.subject,
                    from_email: email.from_email,
                    to_email: [],
                    copy_email: [],
                    ticket_id: email.ticket_id,
                    is_received: email.is_received,
                    is_forward: true,
                    forwarded_email: email,
                    forwarded_attachments: (email.attachments ?? []).map(att => ({
                        filename: att.filename,
                        email_id: email.id,
                    })),
                    references: null,
                    thread_index: null,
                };
            } else {
                this.replyEmail = {
                    id: email.id,
                    in_reply_to: email.message_id,
                    protocol: this.ticketInfo.protocol,
                    subject_email: email.subject,
                    from_email: email.from_email,
                    to_email: email.to_email,
                    copy_email: email.copy_email,
                    ticket_id: email.ticket_id,
                    is_received: email.is_received,
                    reply_email: email,
                    references: email.references,
                    thread_index: email.thread_index,
                };
            }

            this.showEmailEditor = true;
        },
        openModal(ticket) {
            const firstEmail = ticket.emails[0];
            ticket.from_email = firstEmail?.from_email && Array.isArray(firstEmail.from_email) ? firstEmail?.from_email[0] : firstEmail?.from_email;
            ticket.to_email = firstEmail?.to_email && Array.isArray(firstEmail.to_email) ? firstEmail?.to_email[0] : firstEmail?.to_email;
            this.selectedFields.user = ticket.owner_user?.id ?? null;
            this.selectedFields.group = ticket.owner_group?.id ?? null;
            this.selectedFields.priority = ticket.priority?.id ?? null;
            this.selectedStatus = ticket.status?.id ?? null;
            this.originalTicketData.client = ticket.client;
            this.ticketInfo = ticket;
            this.replyEmail = ticket;
            this.allEmails = ticket.emails;
            this.$bvModal.show('bv-modal-ticket');
        },
        closeModal() {
            this.closingComment = {
                visible: false,
                text: ''
            };
            this.editMode = false;
            this.$bvModal.hide('bv-modal-ticket');
        },
        getGroups() {
            axios.get("/ticket/groups")
                .then(({ data }) => {
                    if (data) this.allGroups = data.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                            members: item.members,
                        }
                    });
                });
        },
        getUsers() {
            axios.get("/simple-list-users")
                .then(({ data }) => {
                    if (data) this.allUsers = data.map(item => {
                        return {
                            id: item.id,
                            name: item.name,
                        }
                    });
                });
        },
        getStatuses() {
            axios.get("/ticket/status").then(({ data }) => {
                if (data) this.statuses = data.map(item => {
                    return {
                        id: item.id,
                        name: item.name,
                        color: item.color,
                        is_finisher: item.is_finisher,
                    }
                });
            });
        },
        eventEmailSent(data) {
            this.showEmailEditor = false;
            this.replyEmail = null;
            if (data?.timeline) this.ticketInfo.timeline.push(data.timeline);
            if (data?.email && data?.email?.id) {
                this.ticketInfo.emails.push(data.email.id);
                this.allEmails.push(data.email);
            };
        },
        handleForm() {
            try {
                if (this.closingComment.visible) {
                    if (!this.closingComment.text) {
                        Swal.fire({
                            type: 'error',
                            text: 'É obrigatório inserir um comentário para encerrar o ticket!',
                        });
                        return false;
                    }

                    if (!this.selectedFields.user) {
                        Swal.fire({
                            type: 'error',
                            text: 'É obrigatório selecionar um atendente para encerrar o ticket!',
                        });
                        return false;
                    }
                }
                const foundStatus = this.statuses.find(item => item.id == this.selectedStatus);
                if (foundStatus) this.ticketInfo.status = foundStatus;

                const foundGroup = this.allGroups.find(item => item.id == this.selectedFields.group);
                if (foundGroup) this.ticketInfo.owner_group = foundGroup;

                const foundUser = this.allUsers.find(item => item.id == this.selectedFields.user);
                if (foundUser) this.ticketInfo.owner_user = foundUser;

                const foundPriority = this.prioritiesList.find(item => item.id == this.selectedFields.priority);
                if (foundPriority) this.ticketInfo.priority = foundPriority;

                return {
                    id: this.ticketInfo.id,
                    client: this.ticketInfo.client,
                    owner_user: this.ticketInfo.owner_user,
                    owner_group: this.ticketInfo.owner_group,
                    priority: this.ticketInfo.priority,
                    status: this.ticketInfo.status,
                    chamado: this.ticketInfo.chamado,
                    comment: this.closingComment.text,
                }
            } catch (error) {
                console.error(error);
                Swal.fire({
                    type: 'error',
                    text: 'Falha ao atualizar ticket, por favor, valide todos os campos!',
                });
                return false;
            }
        },
        updateTicket() {
            const form = this.handleForm();
            if (!form) return;

            axios.put("/ticket/update", form)
                .then(({ data }) => {
                    this.ticketInfo.client = data.client;
                    this.ticketInfo.owner_user = data.owner_user;
                    this.ticketInfo.owner_group = data.owner_group;
                    this.ticketInfo.priority = data.priority;
                    this.ticketInfo.status = data.status;
                    this.ticketInfo.updatedAt = data.updatedAt;
                    this.editMode = false;
                    Swal.fire({
                        type: 'success',
                        text: 'Ticket salvo com sucesso',
                        timer: 1000,
                    }).then(() => {
                        if (data) {
                            this.$emit("updateTicketTable", data);
                            if (data?.status?.name == "concluído" || data?.status?.is_finisher) {
                                this.closeModal();
                            }
                        }
                    });
                }).catch(error => {
                    console.error(error);
                    Swal.fire({
                        type: 'error',
                        text: 'Falha ao atualizar ticket, por favor, valide todos os campos!',
                    });
                });
        },
        saveComment() {
            if (!this.newComment) return;

            axios.post("/ticket/createComment", {
                text: this.newComment,
                ticket_id: this.ticketInfo.id,
            }).then(({ data }) => {
                Swal.fire({
                    type: 'success',
                    text: 'Comentário salvo com sucesso',
                    timer: 1000,
                });
                this.ticketInfo.comments.push(data);
                this.newComment = null;
            });
        },
        handleEmailsArray(emails) {
            if (!Array.isArray(emails)) return emails;
            return emails.join("; ");
        },
        cancelEdit() {
            this.selectedFields.user = this.ticketInfo.owner_user?.id ?? null;
            this.selectedFields.group = this.ticketInfo.owner_group?.id ?? null;
            this.selectedFields.priority = this.ticketInfo.priority?.id ?? null;
            this.selectedStatus = this.ticketInfo.status?.id ?? null;
            this.ticketInfo.client = this.originalTicketData.client;
            this.closingComment = {
                visible: false,
                text: ''
            };
            this.editMode = false;
        },
        emailSubTitle(email) {
            if (email.is_received) {
                return `Recebido em: ${this.formatDate(email.created_at)}`;
            } else {
                return `Enviado em: ${this.formatDate(email.created_at)}`;
            }
        },
        async downloadEmails() {
            if (!this.allEmails || this.allEmails.length === 0) {
                Swal.fire({
                    type: 'warning',
                    text: 'Não há e-mails para baixar',
                });
                return;
            }

            try {
                this.loadDownload = true;
                const response = await axios.get(`/ticket/${this.ticketInfo.id}/download-emails`, {
                    responseType: 'blob',
                });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.download = `Ticket_${this.ticketInfo.protocol}_Emails.zip`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);

                this.loadDownload = false;
                Swal.fire({
                    type: 'success',
                    text: 'E-mails baixados com sucesso!',
                    timer: 2000,
                    toast: true,
                    showConfirmButton: false,
                    position: 'top-end'
                });
            } catch (error) {
                this.loadDownload = false;
                console.error('Erro ao baixar e-mails:', error);
                Swal.fire({
                    type: 'error',
                    text: 'Erro ao baixar e-mails. Por favor, tente novamente.',
                });
            }
        },
        async downloadAttachment(emailId, filename) {
            if (!emailId || !filename) return;

            try {
                const response = await axios.get(`/emails/${emailId}/attachment/${encodeURIComponent(filename)}`, {
                    responseType: 'blob',
                });

                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(link.href);
            } catch (error) {
                console.error('Erro ao baixar anexo:', error);
                Swal.fire({
                    type: 'error',
                    text: 'Erro ao baixar o anexo. Por favor, tente novamente.',
                });
            }
        },
        handleKeyWordText(keyword) {
            if (!keyword?.type) return 'Palavra-chave';
            if (keyword.type === "keyword") return 'Palavra-chave';
            if (keyword.type === "rule") return 'Regra';
            return '';
        },
        async openNewTask() {
            if (!this.taskMetaLoaded) {
                await this.fetchTaskMeta();
            }

            const currentUserId = user.getIdPrefix();

            const pendente = this.taskStatusesList.find(s => s.name.toLowerCase().includes('pendente'));
            const userGroup = this.taskGroupsList.find(g =>
                Array.isArray(g.members) && g.members.some(m => m.id === currentUserId)
            );

            const description = [
                this.ticketInfo.client ? `Ticket do cliente ${this.ticketInfo.client}` : null,
                this.ticketInfo.chamado ? `chamado: ${this.ticketInfo.chamado}` : null,
            ].filter(Boolean).join(', ');

            const defaults = {
                title: this.allEmails[0]?.subject || '',
                channel: 'email',
                ref_protocol: this.ticketInfo.protocol || '',
                description: description || '',
                user_id: currentUserId || null,
                group_id: userGroup?.id ?? null,
                status_id: pendente?.id ?? null,
                ticket_id: this.ticketInfo.id ?? null,
            };

            this.$refs.taskFormModal.open(defaults);
        },
        async fetchTaskMeta() {
            try {
                const [priorities, statuses, groups, users, reasons] = await Promise.all([
                    taskManagerAxios.get('/priorities'),
                    taskManagerAxios.get('/statuses'),
                    taskManagerAxios.get('/groups'),
                    taskManagerAxios.get('/users'),
                    taskManagerAxios.get('/reasons'),
                ]);
                this.taskPrioritiesList = priorities.data ?? [];
                this.taskStatusesList = statuses.data ?? [];
                this.taskGroupsList = groups.data ?? [];
                this.taskUsersList = users.data ?? [];
                this.taskReasonsList = reasons.data ?? [];
                this.taskMetaLoaded = true;
            } catch (e) {
                console.error('[TicketDetailsModal] fetchTaskMeta:', e);
            }
        },
        newTimelineTask(data) {
            if (!data?.ticket_id) return;
            const userName = window?.user?.getName() ? window.user.getName() : null;
            const event = {
                event: 'Nova tarefa criada',
                detail: `Uma nova tarefa foi criada com os dados desse ticket ${userName ? 'pelo usuário ' + userName : ''}`,
                ticket_id: data.ticket_id
            }

            axios.post("/ticket/timeline", event)
                .then(({ data }) => {
                    if (data) this.ticketInfo.timeline.push(data);
                }).catch(error => {
                    console.error(error);
                });
        }
    },
}
</script>

<style scoped>
.modal-log {
    position: relative;
    margin: 10% auto;
    max-height: 50em;
    padding: 30px;
    max-width: 60em;
    border-radius: 4px !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
    background-color: #FAFAFA;
    overflow-y: auto;
}

.avoid-page-break {
    page-break-inside: avoid;
}
</style>

<style scoped>
.writter-comment-area {
    margin-top: 40px;
    border-top: 1px solid #c2c2c2;
    padding-top: 10px;
}

.email-content-area {
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 20px;
    margin-bottom: 20px;
}

.email-content-area>h4 {
    margin-bottom: 15px;
    color: #333;
}

.email-content-body {
    border-bottom: 1px solid #e6e6e6;
    margin: 10px 0px;
}

.email-content-header {
    border-bottom: 1px solid #c2c2c2;
    padding-bottom: 10px;
}

.btns-edit {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
}

.input-edit-mode {
    height: 30px;
    width: 100%;
    font-size: 14px;
    border: 1px solid #c2c2c2;
    border-radius: 5px !important;
    padding: 2px 5px;
}

.ticket-id {
    font-weight: bold;
    color: #2e8b8b;
    cursor: pointer;
}

.ticket-id:hover {
    text-decoration: underline;
}

.highlight-badge {
    padding: 5px 10px;
    border-radius: 5px !important;
    font-size: 12px;
    font-weight: bold;
}

.status-atendimento {
    background-color: #fff3e0;
    color: #ef6c00;
}

.status-aguardando {
    background-color: #f3e5f5;
    color: #7b1fa2;
}

.status-resolvido {
    background-color: #e8f5e8;
    color: #2e7d32;
}

.sla-indicator {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 10px;
}

.sla-circle {
    width: 12px;
    height: 12px;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 8px;
    font-weight: bold;
}

.sla-ok {
    background: #4caf50;
    color: white;
}

.sla-warning {
    background: #ff9800;
    color: white;
}

.sla-critical {
    background: #f44336;
    color: white;
}

.sla-overdue {
    background: #d32f2f;
    color: white;
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.ticket-details {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
}

.ticket-info {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 6px !important;
    margin-bottom: 5px;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.info-label {
    font-size: 10px;
    color: #666;
    font-weight: bold;
    text-transform: uppercase;
}

.info-value {
    font-size: 12px;
    color: #333;
    font-weight: 500;
}

.timeline {
    background: white;
    border: 1px solid #ddd;
    border-radius: 6px !important;
    padding: 15px;
}

.timeline-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 15px;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
}

.timeline-item {
    display: flex;
    gap: 12px;
    margin-bottom: 15px;
    position: relative;
}

.timeline-item:not(:last-child)::after {
    content: '';
    position: absolute;
    left: 10px;
    top: 21px;
    width: 2px;
    height: calc(100% + 3px);
    background: #e0e0e0;
}

.timeline-icon {
    width: 20px;
    height: 20px;
    background: #ffffff;
    border-radius: 50% !important;
    border: 1px solid #c2c2c2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: white;
    flex-shrink: 0;
    box-shadow: 1px 1px 1px black;
}

.timeline-content {
    flex: 1;
}

.timeline-title {
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 2px;
}

.timeline-time {
    font-size: 10px;
    color: #666;
    margin-bottom: 5px;
}

.timeline-description {
    font-size: 11px;
    color: #333;
    line-height: 1.4;
}

.timeline-label-events {
    background-color: #c1121f;
    color: white;
}

.internal-comment {
    background: #fff3cd;
    border-left: 3px solid #ffc107;
    padding: 8px;
    margin-top: 5px;
    border-radius: 0 4px 4px 0 !important;
}

.comment-section {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.comment-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.comment-input {
    width: 100%;
    min-height: 80px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px !important;
    font-size: 12px;
    resize: vertical;
}

.comment-actions {
    display: flex;
    gap: 10px;
}

.btn {
    padding: 8px 15px;
    border: 1px solid;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 11px;
    font-weight: bold;
    transition: all 0.3s;
}

.btn-primary {
    background-color: #2e8b8b;
    color: white;
    border-color: #2e8b8b;
}

.btn-primary:hover {
    background-color: #246969;
}

.btn-secondary {
    background-color: #6c757d;
    color: white;
    border-color: #6c757d;
}

.btn-warning {
    background-color: #ffc107;
    color: #333;
    border-color: #ffc107;
}

.btn-success {
    background-color: #28a745;
    color: white;
    border-color: #28a745;
}

.btn-success:hover {
    background-color: #218838;
}

.btn-danger {
    background-color: #dc3545;
    color: white;
    border-color: #dc3545;
}

.btn-task-shortcut {
    background-color: #1c869a;
    color: white;
    border-color: #1c869a;
}

.btn-task-shortcut:hover {
    background-color: #166d7e;
}

.ticket-details {
    grid-template-columns: 1fr;
}

.email-card-accordion {
    margin: 10px 0px;
}

.composer-attachments {
    margin-top: 15px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.composer-attachments>h5 {
    font-size: 13px;
    margin: 0 0 10px 0;
    color: #333;
}

.composer-attachments>ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
}

.composer-attachments>ul>li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border-radius: 4px;
    font-size: 12px;
    border: 1px solid #e9ecef;
    transition: background-color 0.2s;
    text-align: center;
}

.composer-attachments>ul>li:hover {
    background: #e9ecef;
}

.composer-attachments>ul>li>span {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 6px;
    flex-grow: 1;
    justify-content: center;
}

.composer-attachments>ul>li>span>i {
    color: #2e8b8b;
    font-size: 18px;
    /* margin-bottom: 4px; */
}

.attachment-size {
    color: #6c757d;
    font-size: 10px;
}

.download-attachment-btn {
    background: none;
    border: none;
    color: #2e8b8b;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 3px;
    text-decoration: none;
    transition: all 0.2s;
    font-size: 12px;
}

.download-attachment-btn:hover {
    background-color: #2e8b8b;
    color: white;
    text-decoration: none;
}

/* Responsive grid for smaller screens */
@media (max-width: 768px) {
    .composer-attachments>ul {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 480px) {
    .composer-attachments>ul {
        grid-template-columns: 1fr;
    }
}
</style>